import { sendPostRequest } from "@k/global/axiosFormWrapper.js";
export class UserManagementLoginBackendBridge {
    constructor(sprache, land) {
        this.sprache = sprache;
        this.land = land;
    }
    login(username, password, success, fail) {
        sendPostRequest("/konfigurator_php/sessiondata/#login.php", {
            username: username,
            password: password,
            language: this.sprache,
            land: this.land
        }).then(response => success(response.data.login, response.data)).catch(fail);
    }
}
//# sourceMappingURL=loginBackendBridge.js.map